import React, { ReactNode } from "react";
import { Box } from "@mui/material";

import { BlockedAlert, WarningAlert } from "./Alerts";

interface RecalculationStatusAlertsProps {
  isJobRunning: boolean;
  isWarning: boolean;
  infoAlert: ReactNode;
}

/** Shared alert stack for both Filter Mode and GUID Mode: blocked takes over everything else,
 * otherwise show the large-count warning (when applicable) alongside the mode-specific info alert. */
export const RecalculationStatusAlerts = ({
  isJobRunning,
  isWarning,
  infoAlert,
}: RecalculationStatusAlertsProps) => {
  if (isJobRunning) return <BlockedAlert />;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.75 }}>
      {isWarning && <WarningAlert />}
      {infoAlert}
    </Box>
  );
};
